var base = '_3rnorz0';
var dragging = '_3rnorz1';
var draggingBody = '_3rnorz2';

export { base, dragging, draggingBody };
//# sourceMappingURL=use-drag.css.js.map
